<template>
  <div class="login-container">
    <div @click="home" class="close">
      <CloseIcon />
      <span class="close-text">ESC</span>
    </div>
    <LogoTile />
    <span class="title">Reset password</span>
    <div class="subtitle">
      Remembered it?
      <router-link
        :to="{ name: 'Login' }"
        class="white-link"
        tabindex="0"
      >
        <span>Sign in</span>
      </router-link>.
    </div>
    <div class="login-content">
      <div class="inputs">
        <div class="floating-label has-icon">
          <input
            v-model="email"
            placeholder="Please enter your email"
            type="email"
            name="email"
            id="email"
            autofocus
            autocomplete="off"
            @keyup.enter="handleEnter"
          />
          <label for="email">Email</label>
          <div class="input-icon">
            <MailIcon class="icon mini" />
          </div>
        </div>
      </div>
      <button
        @click="resetPasswordRequest"
        class="button-default big submit-button"
        :disabled="!email || loading"
        tabindex="0"
      >
        <span>{{ loading ? "Loading..." : "Request New Password" }}</span>
      </button>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <ErrorIcon />
      </template>
    </SnackBar>
  </div>
</template>
<script>
import LogoTile from "@/components/LogoTile";
import CloseIcon from "../../../../public/img/icons/close.svg";
import MailIcon from "@/assets/img/svg/mail.svg";
import ErrorIcon from "../../../../public/img/icons/error.svg";
import { M_RESET_PASSWORD_REQUEST } from "@/graphql";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  components: {
    LogoTile,
    CloseIcon,
    MailIcon,
    ErrorIcon,
    SnackBar
  },
  name: "ForgotPassword",
  data() {
    return {
      email: null,
      loading: false
    };
  },
  async mounted() {},
  methods: {
    async resetPasswordRequest() {
      const { email } = this;
      try {
        this.loading = true;
        await this.$apollo.mutate({
          mutation: M_RESET_PASSWORD_REQUEST,
          variables: {
            email
          }
        });
        await this.$store.dispatch("snack", {
          text: `Success! Please check your email.`
        });
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: err.message.replace("GraphQL error: ", "")
        });
      } finally {
        this.loading = false;
      }
    },
    handleEnter() {
      if (!this.email || this.loading) {
        return;
      } else {
        this.resetPasswordRequest();
      }
    },
    async home() {
      await this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .close {
    cursor: pointer;
    position: fixed;
    top: 44px;
    right: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .close-text {
        color: white;
      }
    }
    svg {
      width: 18px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    .inputs {
      margin-top: 30px;
      width: 100%;
      display: grid;
      grid-gap: 18px;
    }
    .forgot {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .submit-button {
      margin-top: 22px;
      width: 100%;
    }
    .sign-up {
      margin-top: 69px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .signup-text {
        margin-bottom: 10px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
    }
  }
  .white-link {
    color: #fff;
    cursor: pointer;
  }
}
</style>
